import { toast } from 'react-toastify';
import { ProgramStudentStatus } from '../../../../../api/types/programs/students/program-student-status';
import appApi from '../../../../../api/app-api';
import globalProgramStore from '../../../../../stores/program-store';

export const updateProgramStudentStatusOperation = async (
  branchId: number,
  programId: number,
  studentId: number,
  status: ProgramStudentStatus,
  statusDate: Date | null,
  setLoading: (loading: boolean) => void,
  onHide: () => void,
) => {
  try {
    if (!status) {
      toast.warn('יש לבחור סטטוס');
      return;
    }

    if (!statusDate) {
      toast.warn('יש לבחור תאריך');
      return;
    }

    setLoading(true);
    const response = await appApi.updateProgramStudentStatus(
      branchId,
      programId,
      studentId,
      status,
      statusDate,
    );

    // Update the program details in the store
    if (response.data.body) {
      globalProgramStore.updateProgramDetails(programId, response.data.body);
    }

    setLoading(false);
    onHide();
    toast.success('סטטוס הסטודנט עודכן בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('עדכון סטטוס הסטודנט נכשל, נסה שוב בעוד מספר רגעים');
    console.error(
      `updateProgramStudentStatusOperation failed with programId: ${programId}, studentId: ${studentId}, status: ${status}, error: ${e}`,
    );
  }
};
